module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00603.ec5aaac1.jpg";